module.exports = __webpack_public_path__ + "static/media/hibernate.3dd56543.svg";